import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';

/**
 * Extract values from an array of data elements
 * @param {Array} dataElementArray - Array of data elements (can be objects with .value or strings)
 * @returns {Array} - Array of string values
 */
export const extractDataElementValues = (dataElementArray) => {
	if (!Array.isArray(dataElementArray) || dataElementArray.length === 0) {
		return [];
	}

	return dataElementArray
		.map((item) => {
			if (typeof item === 'object' && item !== null && item.value) {
				return item.value;
			}
			return String(item);
		})
		.filter((val) => val !== undefined && val !== null);
};

/**
 * Render data element array as chips
 */
export const DataElementChips = ({ dataElementArray, classes, label, showLabel = true }) => {
	const values = extractDataElementValues(dataElementArray);

	if (values.length === 0) {
		return (
			<Box mb={2}>
				{showLabel && label && (
					<Typography variant="subtitle2" className={classes?.fieldLabel} style={{ minWidth: 180 }}>
						{label}:
					</Typography>
				)}
				<Typography color="textSecondary">(Empty)</Typography>
			</Box>
		);
	}

	return (
		<Box display="flex" flexWrap="wrap">
			{values.map((val, index) => (
				<Chip
					key={index}
					label={val}
					className={classes?.chip}
					size="small"
					style={{ marginRight: 8, marginBottom: 8 }}
				/>
			))}
		</Box>
	);
};

/**
 * Render data element array as comma-separated text
 */
export const DataElementText = ({ dataElementArray, classes, label, showLabel = true }) => {
	const values = extractDataElementValues(dataElementArray);

	if (values.length === 0) {
		return (
			<Box mb={2}>
				{showLabel && label && (
					<Typography variant="subtitle2" className={classes?.fieldLabel} style={{ minWidth: 180 }}>
						{label}:
					</Typography>
				)}
				<Typography color="textSecondary">(Empty)</Typography>
			</Box>
		);
	}

	return (
		<Box mb={2}>
			{showLabel && label && (
				<Typography variant="subtitle2" className={classes?.fieldLabel} style={{ minWidth: 180 }}>
					{label}:
				</Typography>
			)}
			<Typography>{values.join(', ')}</Typography>
		</Box>
	);
};

